import { render, staticRenderFns } from "./newTarget.vue?vue&type=template&id=ba6fa9fa&"
import script from "./newTarget.vue?vue&type=script&lang=js&"
export * from "./newTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports